import axios, { type AxiosError } from 'axios';

export function isAxiosError<TData = unknown>(
  payload: unknown
): payload is AxiosError<Partial<TData> | undefined> {
  return axios.isAxiosError(payload);
}
